import styled from "@emotion/styled";
import * as React from "react";
import { AppButton } from "../Generic/AppButton";
import { AppAbstractModal } from "../Generic/AppModal/AppAbstractModal";
import Flex from "../Generic/Flex";
import comingSoonLottie from "../../../public/assets/lotties/coming-soon.json";
import Lottie from "react-lottie";
import { translate } from "../../translate";
import { STRINGS } from "../../strings";

interface Props {
  isOpen: boolean;
  onRequestClose?: () => void;
}
const lottieOptions = {
  loop: true,
  autoplay: true,
  animationData: comingSoonLottie,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const AwardsComingSoonModal = (props: Props) => {
  return (
    <AwardsComingSoonModal.Root isOpen={props.isOpen} onRequestClose={props.onRequestClose}>
      <Flex direction="column" alignItems="center" justifyContent="center">
        <Lottie options={lottieOptions} height="50%" width="50%"></Lottie>

        <AwardsComingSoonModal.ModalHeadline>
          {translate(STRINGS.THE_AWARDS_ARE_COMING_SOON)}
        </AwardsComingSoonModal.ModalHeadline>
        <AwardsComingSoonModal.Subtitle>
          {translate(STRINGS.YOU_CAN_COLLECT_YOUR_POINTS_IN_THE_MEANTIME)}
        </AwardsComingSoonModal.Subtitle>
        <AwardsComingSoonModal.CloseButton
          variant="filled"
          color="sexy"
          onClick={props.onRequestClose}
        >
          {translate(STRINGS.CLOSE)}
        </AwardsComingSoonModal.CloseButton>
      </Flex>
    </AwardsComingSoonModal.Root>
  );
};

AwardsComingSoonModal.Root = styled(AppAbstractModal)`
  .container {
    background: #ffffff;
    border-radius: 16px;
    overflow: hidden;
    padding: 15px;
  }
`;

AwardsComingSoonModal.Subtitle = styled.span`
  width: 80%;
  text-align: center;
  margin-bottom: 5px;
  color: var(--gray-500);
  font-size: 16px;
  margin-bottom: 25px;
`;

AwardsComingSoonModal.ModalHeadline = styled.span`
  margin-top: -25px;
  font-size: 22px;
  font-weight: 800;
  text-align: center;
`;

AwardsComingSoonModal.CloseButton = styled(AppButton)`
  width: 70%;
`;

export default React.memo(AwardsComingSoonModal);
